import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'

import { SortableListContainer } from '../../../modules/sortable/index'
import { withPortalAutoRemoteSync } from '../../../modules/common/withPortalAutoRemoteSync'
import PromotionListItem from './PromotionListItem'
import AddPromotionListItem from './AddPromotionListItem'
import PromotionListToolbar from './PromotionListToolbar'
import { addPromotion } from '../../../actions/portal'

class PromotionList extends React.Component {
  state = {
    unsaved: false,
  }

  handlePromotionSort = promotions => {
    this.props.updatePortalAtPath('promotions', promotions)
  }

  handleAddEmptyPromotion = () => {
    if (!this.state.unsaved) this.setState({ unsaved: true })
  }

  handleSavePromotion = promotion => {
    this.props.addPromotion(promotion)
    this.setState({ unsaved: false })
  }

  render() {
    return (
      <div>
        <PromotionListToolbar onAddPromotion={this.handleAddEmptyPromotion} />
        <hr />
        {this.state.unsaved && (
          <AddPromotionListItem onSavePromotion={this.handleSavePromotion} />
        )}
        <SortableListContainer
          items={this.props.portal.promotions}
          itemsDidSorted={this.handlePromotionSort}
          itemComponent={PromotionListItem}
        />
      </div>
    )
  }
}

export default compose(
  connect(null, { addPromotion }),
  withPortalAutoRemoteSync(),
)(PromotionList)



// WEBPACK FOOTER //
// ./src/components/templates/promotion-list/PromotionList.js